const PROFILE_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;

function avatarVersion(value) {
  let hash = 2166136261;
  for (const character of String(value || '')) {
    hash ^= character.charCodeAt(0);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(36);
}

const FALLBACK_COLORS = ['#475569', '#1d4ed8', '#0f766e', '#9f1239', '#6d28d9', '#92400e'];

export function resolveProfileAvatarFallbackColor(id) {
  const normalizedId = typeof id === 'string' ? id.trim().toLowerCase() : '';
  return FALLBACK_COLORS[parseInt(avatarVersion(normalizedId), 36) % FALLBACK_COLORS.length];
}

export function resolveProfileAvatarSrc({ id, avatarUrl } = {}) {
  const normalizedUrl = typeof avatarUrl === 'string' ? avatarUrl.trim() : '';
  if (!normalizedUrl) return null;
  const normalizedId = typeof id === 'string' ? id.trim().toLowerCase() : '';
  if (!PROFILE_ID_PATTERN.test(normalizedId)) return normalizedUrl;
  return `/api/profile/avatar/${normalizedId}?v=${avatarVersion(normalizedUrl)}`;
}
